export default [
  '#e76868',
  '#e7ae68',
  '#cbe768',
  '#77e768',
  '#68e7ae',
  '#68cbe7',
  '#6877e7',
  '#ae68e7',
  '#e768cb',
  '#e76877',

  '#994936',
  '#998c36',
  '#649936',
  '#369949',
  '#36998c',
  '#366499',
  '#493699',
  '#8c3699',
  '#993664',
]
export {

}



// WEBPACK FOOTER //
// ./client/src/charts/colors.js